var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.isEnabled ? `color: green;` : `color: red;`)},[_vm._v(" "+_vm._s(_vm.isEnabled ? _vm.truthy : _vm.falsy)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }